import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../utils/apiRoutes";
import { commonService } from "../../utils/commonService";
import Loader from "../Loader/Loader";
import SupportTicketCreateModal from "./SupportTicketCreateModal";
import { dataTable } from "../../utils/dataTable";
function getListData(data) {
    return data?.DataList1 || data?.dataList1 || [];
}

function getStatusVariant(status) {
    switch ((status || "").toLowerCase()) {
        case "open":
            return "info";
        case "in progress":
            return "primary";
        case "on hold":
            return "warning";
        case "resolved":
            return "success";
        case "closed":
            return "secondary";
        default:
            return "dark";
    }
}

function SupportTicketList({ embedded = false, onViewTicket, createOpen, onCreateOpenChange, reloadToken } = {}) {
    const navigate = useNavigate();
    const userDetail = commonService.getLoginUserData();
    const clientId = Number(userDetail?.clientid || 0);
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [statusFilter, setStatusFilter] = useState("");
    const [ticketNoFilter, setTicketNoFilter] = useState("");
    const isCreateModalOpen = typeof createOpen === "boolean" ? createOpen : showCreateModal;

    const handleCreateModalChange = (value) => {
        if (onCreateOpenChange) {
            onCreateOpenChange(value);
            return;
        }

        setShowCreateModal(value);
    };

    const getTicketList = async (overrides = {}) => {
        const nextStatus = Object.prototype.hasOwnProperty.call(overrides, "status") ? overrides.status : statusFilter;
        const nextTicketNo = Object.prototype.hasOwnProperty.call(overrides, "ticketno") ? overrides.ticketno : ticketNoFilter;

        setLoading(true);
        try {
            const response = await axios.post(
                API_URL.BASE_API_URL.ADMINAPI + API_URL.PUBLIC_SUPPORT_TICKET.GET_LIST,
                {
                    clientid: clientId,
                    status: nextStatus,
                    ticketno: nextTicketNo.trim(),
                }
            );

            if (response?.data?.status_code === 1) {
                setTickets(getListData(response?.data?.data));
            } else {
                setTickets([]);
            }
        } catch (error) {
            setTickets([]);
        }
        setLoading(false);
        dataTable("SupportTicketList");
    };

    useEffect(() => {
        getTicketList();
    }, [reloadToken]);

    const handleApplyFilters = (event) => {
        event?.preventDefault?.();
        getTicketList();
    };

    return (
        <div className={embedded ? "support-ticket-pane" : "content-wrapper support-ticket-pane"}>
            <Form onSubmit={handleApplyFilters} className="">
                <Row className="g-2 align-items-end">
                    <Col md={4} lg={3}>
                        <Form.Label className="small text-muted mb-1">Status</Form.Label>
                        <Form.Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} size="sm">
                            <option value="">All</option>
                            <option value="Open">Open</option>
                            <option value="In Progress">In Progress</option>
                            <option value="On Hold">On Hold</option>
                            <option value="Resolved">Resolved</option>
                            <option value="Closed">Closed</option>
                        </Form.Select>
                    </Col>
                    <Col md={5} lg={4}>
                        <Form.Label className="small text-muted mb-1">Ticket No</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Search by ticket number"
                            value={ticketNoFilter}
                            onChange={(e) => setTicketNoFilter(e.target.value)}
                            size="sm"
                        />
                    </Col>
                    <Col md={3} lg={5} className="d-flex gap-2 justify-content-md-end flex-wrap">
                        <Button type="submit" size="sm" variant="outline-primary" disabled={loading}>
                            Apply
                        </Button>
                        {clientId > 0 && (
                            <Button
                                type="button"
                                size="sm"
                                variant="primary"
                                onClick={() => handleCreateModalChange(true)}
                            >
                                Create Ticket
                            </Button>
                        )}
                    </Col>
                </Row>
            </Form>
            {loading ? (
                <Loader />
            ) : (
                <div className="table__container mt-3">
                    <div className="stripped__table">
                        <Table responsive id="SupportTicketList" className="tbl-support-ticket">
                            <thead>
                                <tr>
                                    <th className="width200">Ticket No</th>
                                    <th>Title</th>
                                    <th className="width200">Category</th>
                                    <th className="width100 text-center">Status</th>
                                    <th className="width200">Created By</th>
                                    <th className="width150">Created On</th>

                                </tr>
                            </thead>
                            <tbody>
                                {tickets?.length > 0 ? (
                                    tickets.map((item) => (
                                        <tr key={item?.ticketid} className="cursor-pointer">
                                            <td onClick={() => {
                                                if (onViewTicket) {
                                                    onViewTicket(item?.ticketid);
                                                    return;
                                                }
                                            }}><a className="support-ticket-no">{item?.ticketno}</a></td>
                                            <td>
                                                {item?.title}
                                            </td>
                                            <td>{item?.category_name || "-"}</td>
                                            <td className="text-center">
                                                <Badge bg={getStatusVariant(item?.status)}>{item?.status || "-"}</Badge>
                                            </td>
                                            <td>{item?.createdby_name || "-"}</td>
                                            <td>{commonService.getDateTimeInFormat(item?.createdon)}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr className="cursor-pointer">
                                        <td></td>
                                        <td className="text-end">No Data Found</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )}
            <SupportTicketCreateModal
                show={isCreateModalOpen}
                onHide={() => handleCreateModalChange(false)}
                onCreated={() => getTicketList()}
            />
        </div>
    );
}

export default SupportTicketList;